import { ScopeButton } from '@monorepo/shared-lib';
import { Input, Row, Space, Typography } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { turnModalOff } from 'store/app/actions';

const { Text } = Typography;

interface SaveViewModalContentProps {
  onSave: (name: string) => void;
  initialValue?: string;
  placeholder?: string;
}

export const SaveViewModalContent: React.FC<SaveViewModalContentProps> = ({
  onSave,
  initialValue = '',
  placeholder,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [viewName, setViewName] = useState(initialValue);
  const resolvedPlaceholder =
    placeholder ?? t('submissions.filter-view-name-placeholder');

  const handleSave = () => {
    if (viewName.trim()) {
      dispatch(turnModalOff());
      onSave(viewName.trim());
    }
  };

  return (
    <>
      <Row justify={'center'} style={{ marginBottom: '12px' }}>
        <Text
          style={{
            textAlign: 'center',
            width: '100%',
            fontSize: '13px',
            color: 'var(--color-text-muted, #5a6a6a)',
            lineHeight: '1.5',
          }}
        >
          {t('submissions.create-view-modal-hint')}
        </Text>
      </Row>
      <Row justify={'center'} style={{ marginBottom: '20px' }}>
        <div style={{ width: '100%' }}>
          <label
            htmlFor="save-view-name-input"
            style={{
              display: 'block',
              marginBottom: '8px',
              fontSize: '14px',
              color: 'var(--color-text-dark, #042a2a)',
            }}
          >
            {t('submissions.view-name-label')}
          </label>
          <Input
            id="save-view-name-input"
            value={viewName}
            onChange={(e) => setViewName(e.target.value)}
            placeholder={resolvedPlaceholder}
            aria-label={t('submissions.view-name-label')}
            onPressEnter={handleSave}
            autoFocus
            style={{ width: '100%' }}
          />
        </div>
      </Row>
      <Row justify={'center'} style={{ paddingTop: '20px' }}>
        <Space>
          <ScopeButton
            type={'default'}
            width={'100px'}
            height={'40px'}
            onClick={() => dispatch(turnModalOff())}
          >
            {t('common.cancel')}
          </ScopeButton>
          <ScopeButton
            type={'primary'}
            width={'fit-content'}
            height={'40px'}
            onClick={handleSave}
            disabled={!viewName.trim()}
          >
            {t('submissions.create-view')}
          </ScopeButton>
        </Space>
      </Row>
    </>
  );
};
